import { render, staticRenderFns } from "./yc-sales-volume.vue?vue&type=template&id=bd5942cc&scoped=true&"
import script from "./yc-sales-volume.vue?vue&type=script&lang=js&"
export * from "./yc-sales-volume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5942cc",
  null
  
)

export default component.exports